<template>
    <div class="gallery-videos">
        <video-responsive :id="currentVideo"></video-responsive>

        <tiny-slider v-if="videos" :mouse-drag="true" items="4" gutter="12">
            <div v-for="(item, i) in videos" v-bind:key="i" class="item" v-on:click="() => handleClick(item.id)">
                <img v-bind:src="'https://img.youtube.com/vi/'+ item.id +'/mqdefault.jpg'" :alt="'Vídeo' + i" />
            </div>
        </tiny-slider>
    </div>
</template>

<style lang="scss">
    .gallery-videos {
        max-width: 960px;
        margin: 0 auto;

        .tns-outer {
            position: relative;
            margin-top: 16px;

            .tns-controls {
                display: none;
                position: absolute;
                top: 50%;
                left: 0;
                width: 100%;
                height: 46px;
                transform: translateY(-50%);

                @media (min-width: 1080px) {
                    display: block;
                }

                button {
                    position: absolute;
                    top: 0;
                    width: 45px;
                    height: 45px;
                    border-radius: 45px;
                    background-color: #530F5C;
                    border: none;
                    appearance: none;
                    font-size: 0;

                    &::before {
                        content: "";
                        border: solid #FFFFFF;
                        display: inline-block;
                        padding: 5px;
                        transform: rotate(135deg);
                    }

                    &:first-of-type {
                        left: -65px;
                        padding-left: 10px;

                        &::before {
                            border-width: 0 2px 2px 0;
                        }
                    }

                    &:last-of-type {
                        right: -65px;
                        padding-right: 10px;

                        &::before {
                            border-width: 2px 0 0 2px;
                        }
                    }
                }
            }
        }

        .item {
            transition: all 250ms ease;

            img {
                width: 100%;
            }

            &:hover {
                opacity: .7;
                cursor: pointer;
            }
        }
    }
</style>

<script>
    import VideoResponsive from './VideoResponsive.vue'

    export default {
        props: {
            videos: {
                type: Array,
                required: true,
            },
            current: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                currentVideo: this.current
            }
        },

        methods: {
            handleClick(id) {
                this.currentVideo = id;
            }
        }
    }
</script>
